<template>
  <v-container>
    <loading
      :active="loader"
      :is-full-page="fullPage"
      :opacity="0.7"
      color="#ff6b00"
      :height="height"
      :width="width"
    />
    <v-row>
      <v-col
        cols="12"
        v-if="isTrans == 'true'"
        class="d-flex w-100 justify-content-end"
      >
        <v-btn color="primary" @click="onClickCancel">
          {{ $t("cancel_beneficary") }}
        </v-btn>
      </v-col>
      <v-col cols="12" md="6">
        <label>{{ $t("bankName") }}<span style="color: #f00">*</span></label>
        <v-autocomplete
          :placeholder="$t('bankName')"
          v-model="beneficiaryReqBody.bank_name"
          :items="bank_names"
          item-text="locationName"
          item-value="locationName"
          :error-messages="bankNameErrors"
          @input="$v.beneficiaryReqBody.bank_name.$touch()"
          @change="onBankSelect"
          required
          outlined
          dense
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="6">
        <label>{{ $t("swift_code_branch") }}</label>
        <v-text-field
          :placeholder="$t('swift_code_placeholder')"
          v-model="beneficiaryReqBody.swift_no"
          outlined
          dense
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="6">
        <label> {{ $t("branch_code_beneficary") }}</label>
        <v-text-field
          :placeholder="$t('branch_code_beneficary')"
          v-model="beneficiaryReqBody.branch_code"
          outlined
          dense
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="6" class="m-0">
        <label
          >{{ $t("account_number_beneficary")
          }}<span style="color: #f00">*</span></label
        >
        <v-text-field
          :placeholder="$t('account_number_beneficary')"
          v-model="beneficiaryReqBody.bank_account_no"
          :error-messages="accountNoErrors"
          @input="$v.beneficiaryReqBody.bank_account_no.$touch()"
          required
          outlined
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="12">
        <v-btn
          class="float-left mt-5 px-5 btn-primary-outlined text-capitalize"
          @click="onClickBack"
          outlined
          ><v-icon dark left>mdi-arrow-left</v-icon> {{ $t("backLabel") }}
        </v-btn>
        <v-btn
          class="float-right mt-5 px-5 btn-primary-outlined text-capitalize"
          @click="onClickNext"
          outlined
          >{{ $t("next") }} <v-icon dark right>mdi-arrow-right</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { required, numeric } from "vuelidate/lib/validators";
import Loading from "vue-loading-overlay";
import commonService from "@/services/AgentCommonService/commonService.js";
export default {
  name: "AccountSection",
  components: {
    Loading,
  },
  data() {
    return {
      name: "",
      isSubmitted: false,
      fullPage: true,
      height: 100,
      width: 100,
      bank_names: [],
    };
  },
  props: {
    beneficiaryReqBody: {
      type: Object,
      required: true,
    },
    loader: {
      type: Boolean,
    },
    BusrecieverData: {
      type: Object,
      required: true,
    },
    isTrans: {
      type: String,
      default: "",
    },
    country_code: {
      type: String,
      default: "",
    },
  },
  validations() {
    return {
      beneficiaryReqBody: {
        bank_name: {
          required,
          selectedBank: (value) =>
            !value || this.bank_names.some((bank) => bank.locationName === value),
        },

        bank_account_no: {
          required,
          numeric,
        },
      },
    };
  },
  computed: {
    bankNameErrors() {
      const errors = [];
      if (!this.$v.beneficiaryReqBody.bank_name.$dirty) return errors;
      if (!this.$v.beneficiaryReqBody.bank_name.required) {
        errors.push(this.$t("select_bank_name"));
      } else if (!this.$v.beneficiaryReqBody.bank_name.selectedBank) {
        errors.push(this.$t("invalid_bank_name"));
      }
      return errors;
    },
    accountNoErrors() {
      const errors = [];
      if (!this.$v.beneficiaryReqBody.bank_account_no.$dirty) return errors;
      !this.$v.beneficiaryReqBody.bank_account_no.required &&
        errors.push(this.$t("account_number"));
      if (!this.$v.beneficiaryReqBody.bank_account_no.numeric) {
        errors.push(this.$t("invalid_account_num"));
      }
      return errors;
    },
  },
  watch: {
    BusrecieverData: {
      handler(data) {
        console.log("data", data);
        this.beneficiaryReqBody.branch_code = data.branch_code;
        this.beneficiaryReqBody.location_name = data.location_name;
        this.beneficiaryReqBody.location_id = data.location_id;
        this.beneficiaryReqBody.bank_name = data.location_name || data.bank_name || "";
        this.beneficiaryReqBody.swift_no = data.swift_no;
        this.beneficiaryReqBody.bank_account_no = data.bank_account_no;
      },
    },
    country_code: {
      immediate: true,
      handler(country, previousCountry) {
        if (previousCountry && previousCountry !== country) {
          this.beneficiaryReqBody.bank_name = "";
          this.beneficiaryReqBody.location_name = "";
          this.beneficiaryReqBody.location_id = "";
        }
        this.getpayLocation(country);
      },
    },
  },
  methods: {
    onClickCancel() {
      this.$router.push("/transaction/3");
    },
    onClickNext() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.$emit("onClickNext", this.beneficiaryReqBody);
    },
    onClickBack() {
      this.$emit("onClickBack");
    },
    onBankSelect(bankName) {
      const bank = this.bank_names.find((item) => item.locationName === bankName);
      this.beneficiaryReqBody.location_id = bank ? bank.locationId : "";
      this.beneficiaryReqBody.location_name = bank ? bank.locationName : "";
    },
    async getpayLocation(country) {
      this.bank_names = [];
      if (!country) return;
      try {
        const response = await commonService.getbankList({
          country,
          payment_mode: "B",
        });
        if (country !== this.country_code) return;
        if (response.status === 200 && Array.isArray(response.data.data)) {
          this.bank_names = response.data.data;
          this.onBankSelect(this.beneficiaryReqBody.bank_name);
        }
      } catch (error) {
        console.error("Unable to load banks", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";
.invalid-feedback-password {
  display: flex;
  flex-direction: column;
  text-align: initial;
  font-size: 13px;
  background-color: #f5f5f5;
  color: #dc3545;
}
.invalid-feedback-confirm {
  display: flex;
  flex-direction: column;
  text-align: initial;
  font-size: 13px;
  background-color: #f5f5f5;
  color: #dc3545;
}
.invalid-feedback-swift {
  display: flex;
  flex-direction: column;
  text-align: initial;
  font-size: 13px;
  background-color: #f5f5f5;
  color: #dc3545;
}
@media (min-width: 768px) {
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
    margin: auto;
  }
}
</style>
